import React from 'react'
import Layout from '../components/Layout/Layout'
import TermsAndConditionsComponent from '../components/TermsAndConditionsComponent'

const TermsAndConditions = () => {
  return (
    <>
     <Layout>
        <TermsAndConditionsComponent />
     </Layout>
    </>
  )
}

export default TermsAndConditions